import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import RateSection from './components/RateSection';
import InfoSection from './components/InfoSection';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <main>
        <section>
          <HeroSection />
        </section>
        <section>
          <RateSection />
        </section>
        <section>
          <InfoSection />
        </section>
        <section>
          <ComparisonSection />
        </section>
        <section>
          <CTASection />
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
